/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { DocumentNode, gql } from "@apollo/client";
import Command from "../../../Basis/Commands/Command";
import Buchungsbestaetigungsversandart from "./Buchungsbestaetigungsversandart";

export interface AendereArtikelEMailEinstellungenInput {
    artikelId: string;
    artikelGeaendert: string;
    eMailText?: string;
    eMailTextEN?: string;
    buchungsbestaetigungsversandart: Buchungsbestaetigungsversandart;
}

export default class AendereArtikelEMailEinstellungen extends Command<void, AendereArtikelEMailEinstellungenInput> {
    public static readonly commandName: string = "Seminare_AendereArtikelEMailEinstellungen";

    private static readonly mutation: DocumentNode = gql`
        mutation ${AendereArtikelEMailEinstellungen.commandName}($input: ${AendereArtikelEMailEinstellungen.commandName}) {
            ${AendereArtikelEMailEinstellungen.commandName}(input: $input)
        }
    `;

    public readonly name: string = AendereArtikelEMailEinstellungen.commandName;

    public constructor(refetchQueries: string[] = []) {
        super(AendereArtikelEMailEinstellungen.mutation, refetchQueries);
    }
}
